import * as helper from './../../../../../VX/View/Assets/Js/helper';
import {initImprint} from "../../../Assets/JS/imprint_la";

// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
if (!(global as any)._babelPolyfill) {
	require('babel-polyfill');
}

helper.onDocumentLoaded(() => {
	initImprint(helper.$('#impressumlink'), helper.$('#datenschutzlink'));

	const container = document.querySelectorAll('.container');
	const stepButtons = document.querySelectorAll('.step-btn');
	const surveys = document.querySelectorAll('.survey');
	const cta = document.querySelector('.next-btn');
	const wrapper = helper.$('#wrapper');
	const url1 = helper.getData(wrapper, 'url1');
	const url2 = helper.getData(wrapper, 'url2');

	let index = 0;

	helper.addClickListener(cta, () => {
		window.open(url1);
		window.location.href = url2;
	})

	let nextStep = async () => {
		await helper.fadeOut(surveys[index]);
		helper.addClass(surveys[index], 'd-none');
		index++;
		if (index < surveys.length) {
			helper.removeClass(surveys[index], 'd-none');
			await helper.fadeIn(surveys[index]);

			if (index === 6) {
				setTimeout(nextStep, 4000);
			}
		} else {
			await helper.fadeOut(container[0]);
			helper.addClass(container[0], 'd-none');

			helper.removeClass(container[1], 'd-none');
			await helper.fadeIn(container[1]);
		}
	};

	stepButtons.forEach((item) => {
		helper.addClickListener(item, (e) => {
			e.preventDefault();
			nextStep();
		})
	})

})
